import React, { useState, useCallback } from 'react';
import { SprayOperator } from '../../services/sprayService';
import SprayOperatorList from './SprayOperatorList';
import SprayOperatorForm from './SprayOperatorForm';

const SprayOperatorsPage: React.FC = () => {
  const [showForm, setShowForm] = useState(false);
  const [editOperator, setEditOperator] = useState<SprayOperator | undefined>();
  const [refreshKey, setRefreshKey] = useState(0);

  const handleAdd = useCallback(() => { setEditOperator(undefined); setShowForm(true); }, []);
  const handleEdit = useCallback((operator: SprayOperator) => { setEditOperator(operator); setShowForm(true); }, []);
  const handleCancel = useCallback(() => { setShowForm(false); setEditOperator(undefined); }, []);
  const handleSave = useCallback(() => {
    setShowForm(false);
    setEditOperator(undefined);
    setRefreshKey(k => k + 1);
  }, []);

  return (
    <div>
      {showForm ? (
        <SprayOperatorForm operator={editOperator} onSave={handleSave} onCancel={handleCancel} />
      ) : (
        <SprayOperatorList key={refreshKey} onAdd={handleAdd} onEdit={handleEdit} />
      )}
    </div>
  );
};

export default SprayOperatorsPage;
